import type React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { ROUTES } from '@xing-com/crate-jobs-paths';
import { space4XL } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

import { Navigation } from './navigation';

export const Container = styled.div`
  margin-bottom: ${space4XL};
`;

export const OTHERS_ITEM = 'weitere';
const JOBS_NAVIGATION_ITEMS = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
];
const COMPANIES_NAVIGATION_ITEMS = [...JOBS_NAVIGATION_ITEMS, OTHERS_ITEM];

export const DirectoriesList: React.FC = () => (
  <>
    <Container>
      {/* @ts-expect-error FIXME: SC6 */}
      <Headline size="large" forwardedAs="h2">
        <FormattedMessage id="XJM_SEO_DIRECTORY_PAGINATION_H" />
      </Headline>
      <Navigation items={JOBS_NAVIGATION_ITEMS} url={ROUTES.jobsDirectory} />
    </Container>
    <Container>
      {/* @ts-expect-error FIXME: SC6 */}
      <Headline size="large" forwardedAs="h2">
        <FormattedMessage id="COMPANY_DIRECTORY_LIST_H" />
      </Headline>
      <Navigation
        items={COMPANIES_NAVIGATION_ITEMS}
        url={ROUTES.jobsCompanyDirectory}
      />
    </Container>
  </>
);
